import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';

@Component({
  standalone: false,
  selector: 'fl-section-feature-button',
  template: `
    <fl-button
      class="SectionAButton"
      [color]="color"
      [size]="ButtonSize.LARGE"
      [sizeDesktop]="ButtonSize.XLARGE"
      [link]="link"
      (click)="buttonClicked.emit()"
      [busy]="busy"
    >
      <ng-content></ng-content>
    </fl-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionFeatureButtonComponent {
  ButtonSize = ButtonSize;

  @Input() color: ButtonColor = ButtonColor.DEFAULT;
  @Input() link: string;
  @Input() busy: boolean;
  @Output() buttonClicked = new EventEmitter<void>();
}
